import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useListIntegrationToken } from 'core/hooks/api'

// Styled Elements
import { TableWrapper } from './ApiKeysTable.elements'

// Views
import { Table, LoadingTablePlaceholder } from 'views/components'

// Layouts
import ApiKeysTableItem from '../ApiKeysTableItem/ApiKeysTableItem'
import ApiKeysTableHeader from '../ApiKeysTableHeader'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function ApiKeysTable(props) {
  // Destructure
  const { ui, actions } = props

  // Store States
  const { isPageTableUpdated } = ui
  const { setIsPageTableUpdated } = actions

  // Hooks
  const { listIntegrationToken, listIntegrationTokenData, isListIntegrationTokenLoading } = useListIntegrationToken()
  // const [currentUser] = useLocalStorage('userCredentials', {})

  // Local states
  const [apiKeys, setApiKeys] = useState([])

  // UseEffects
  useEffect(() => {
    listIntegrationToken()
  }, [])
  useEffect(() => {
    if (listIntegrationTokenData) {
      setApiKeys(listIntegrationTokenData)
    }
  }, [listIntegrationTokenData])
  useEffect(() => {
    if (isPageTableUpdated) {
      listIntegrationToken(listIntegrationToken)
      setIsPageTableUpdated(false)
    }
  }, [isPageTableUpdated])
  return (
    <TableWrapper>
      <Table hidePagination tableFilters={{ size: 0, page: 0 }} minWidth={900}>
        {isListIntegrationTokenLoading && <LoadingTablePlaceholder />}
        {!isListIntegrationTokenLoading && apiKeys.length > 0 && <ApiKeysTableHeader />}
        {!isListIntegrationTokenLoading &&
          apiKeys.length > 0 &&
          apiKeys.map((data) => <ApiKeysTableItem key={data.id} data={data} setIsUpdated={setIsPageTableUpdated} />)}
      </Table>
    </TableWrapper>
  )
}

// Default Props
ApiKeysTable.defaultProps = {
  actions: {},
  filters: {},
  ui: {},
}

// Proptypes Validation
ApiKeysTable.propTypes = {
  filters: PropTypes.shape({
    reportsFilters: PropTypes.instanceOf(Object),
  }),
  ui: PropTypes.shape({
    isPageTableUpdated: PropTypes.bool,
  }),
  actions: PropTypes.shape({
    setToBeUpdatedAccount: PropTypes.func,
    setAccountDirectoryFilters: PropTypes.func,
    setIsIndividualAccountDrawerOpen: PropTypes.func,
    setIsEntityAccountDrawerOpen: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setReportsFilters: PropTypes.func,
    showAlert: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiKeysTable)
